export const InviteeNotMatchReason = {
  Registered: 1,
  NoInvitation: 2,
  KOLChannel: 3,
};
